import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
}), 'ShortText');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ShortText.js
// module id = 6113
// module chunks = 2